import qs from 'query-string';
import { HomeTabListRequestDto } from '../../../types/home/tab';
import SuperFetchV2 from '../../superFetchV2';
import { HomeListRequestDto } from '../../../types/home/list';
import { HomesFindAllResponseBodyDto } from '../../../types/api/homes';
import {
  HomeTabsBulkUpdateRequestBodyDto,
  HomeTabsBulkUpdateResponseBodyDto,
  HomeTabsCreateRequestBodyDto,
  HomeTabsCreateResponseBodyDto,
  HomeTabsFindAllResponseBodyDto,
  HomeTabsUpdateRequestBodyDto,
} from '../../../types/api/home-tabs';

export const homeApiV2 = {
  getHomeList: (payload: HomeListRequestDto): Promise<HomesFindAllResponseBodyDto> =>
    SuperFetchV2.get(`/homes?${qs.stringify(payload, { skipNull: true })}`),
  getHomeTabList: (payload: HomeTabListRequestDto): Promise<HomeTabsFindAllResponseBodyDto> =>
    SuperFetchV2.get(`/home-tabs?${qs.stringify(payload, { skipNull: true })}`),
  createHomeTab: (payload: HomeTabsCreateRequestBodyDto): Promise<HomeTabsCreateResponseBodyDto> =>
    SuperFetchV2.post(`/home-tabs`, payload),
  editHomeTab: (id: number, payload: HomeTabsUpdateRequestBodyDto): Promise<HomeTabsCreateResponseBodyDto> =>
    SuperFetchV2.patch(`/home-tabs/${id}`, payload),
  editHomeTabList: (homeTabList: HomeTabsBulkUpdateRequestBodyDto): Promise<HomeTabsBulkUpdateResponseBodyDto> =>
    SuperFetchV2.patch('/home-tabs/bulk', homeTabList),
};
